import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/header";
import Footer from "./components/footer";
import Home from "./pages/Home";
import Rooms from "./pages/rooms";
import Amenities from "./pages/amenities";
import Contact from "./pages/contact";
import Photo from "./pages/photo";
import SeoKeywordPage from "./pages/SeoKeywordPage";
import "./App.css";
function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/rooms" element={<Rooms />} />
          <Route path="/amenities" element={<Amenities />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/photo" element={<Photo />} />
          <Route path="/pet-friendly-hotel-ocean-shores" element={<SeoKeywordPage />} />
          <Route path="/hotel-with-pool-ocean-shores-wa" element={<SeoKeywordPage />} />
          <Route path="/cheap-hotel-ocean-shores-wa" element={<SeoKeywordPage />} />
          <Route path="/hotel-near-ocean-shores-beach" element={<SeoKeywordPage />} />
          <Route path="/ocean-shores-hotel-with-free-parking" element={<SeoKeywordPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </HelmetProvider>
  );
}
export default App;
